module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "content-chapter1",
    attrs: {
      "id": "_idParaDest-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/MakingVeganMeat5#_idTextAnchor001"
    }
  }, [_vm._v("How Did I End Up Here?"), _c('span', {
    attrs: {
      "id": "_idTextAnchor064"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "body_Body--Left-Justify-"
  }, [_vm._v("From a young age, I always was interested in how stuff works, how it’s made, and how the heck I could make it at home. This was everything from electronics to musical instruments, cars, toys—everything. Needless to say, I took a "), _c('span', {
    staticClass: "Italics _idGenCharOverride-1"
  }, [_vm._v("lot")]), _vm._v(" of things apart and tried to put them back together. Pair that need to figure things out with a need to create something new, and you end up with Sauce Stache. Sauce Stache started as an outlet for my creativity, and a way to create something fun and interesting. Its original intention was sauce recipes. In early 2016, I started dating Monica, my fiancée. At the time, she ran a yoga blog and YouTube channel. I loved what she did and her passion for creating content and running her own business built around the blog; it was a topic that came up quite early on in our relationship. Sometime near the end of August 2016, Monica said I should make a blog based on my sauce recipes, something I made often when I would cook for our early dates. That blog idea quickly shifted into a YouTube channel. I had fun during the first few months of Sauce Stache—learning how to edit and film videos, buying my first real camera from a pawn shop—but it quickly changed into me wanting to do more. I stepped in front of the camera about nine months later and started making videos about trends, secretly keeping them mostly pescatarian, using vegan products wher"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("e")]), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v(" I")]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("could.")])]), _vm._v(" "), _c('p', {
    staticClass: "content-chapter1",
    attrs: {
      "id": "_idParaDest-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/MakingVeganMeat5#_idTextAnchor002"
    }
  }, [_vm._v("Why Plant-Based Food?"), _c('span', {
    attrs: {
      "id": "_idTextAnchor065"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "body_Body--Left-Justify-"
  }, [_vm._v("I love plant-based food. It opens a whole new world of culinary adventure that you can feel good about and bonus—you get to save animals. Everyone has their own reasons for eating plant-based foods, either health-based, animal-based, environmental-based, all of the above, or a million reasons in between. Making plant-based food is where I can be my most creative, trying new ways, using new techniques, to make food better. I am not trying to reinvent the wheel, just make the wheel taste more like steak than anyone else has. Plant-based diets have been around for a "), _c('span', {
    staticClass: "Italics _idGenCharOverride-1"
  }, [_vm._v("long")]), _vm._v(" time, all the way back to before 300 BC, and plant-based meat isn’t something that’s new or trendy. Early vegetarians would boil soy milk to make soy skin, then take that soy skin and tightly pack it together with seasonings and flavors to create a mock meat that had texture and flavors similar to real meat! Plant-based meat has a ton of room for improvement. I want to be a part of this journey and it seems like y"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("ou do")]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("too.")])]), _vm._v(" "), _c('p', {
    staticClass: "content-chapter1",
    attrs: {
      "id": "_idParaDest-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/MakingVeganMeat5#_idTextAnchor003"
    }
  }, [_vm._v("How Do I Use This Cookbook?"), _c('span', {
    attrs: {
      "id": "_idTextAnchor066"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "body_Body--Left-Justify-"
  }, [_vm._v("I love to find analogies to make things feel easier than they are. This will hopefully be like doing a test backward with all the answers laid out in front of you. Skip the next part, where I explain all the bases, textures, and additives, and how I use them; make some recipes first, figure out what you like and don’t like. Do you like the texture of one recipe, but not some of the flavors? Head to the ingredients index on the next few pages and check out the cross-referencing section to see if you can plan a flavor combo that you think you’ll like better. Do that over and over again. Then you can start putting together your own"), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("creations!")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b24accac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MakingVeganMeat-8.vue
// module id = 84
// module chunks = 0